import React from 'react';
import Layout from 'Layout/Layout';
import Loader from 'Layout/Loader';

class GenericPlaceholder extends React.Component {
    render() {
        return (
            <Layout page="placeholder">
                <div className="full-height">
                    <Loader />
                </div>
            </Layout>
        );
    }
}

export default GenericPlaceholder;
